$(document).ready(function() {
    var index = $('.product__thumbs--scroller [data-left-frame]').data('index');
      var flkty = Flickity.data('.product-slideshow');
      if(flkty)
      {
flkty.select(index);
      }
      
      
    function updateDataAttributes() {
        var selectedSize = $('input[name="Size"]:checked').val();
        var selectedFrame = $('input[name="Frame"]:checked').val();
        // var selectedBorder = $('input[name="Border Options"]:checked').val();
        var selectedBorder = document.querySelector('.amr-Border .variant_select-product.active_seclet .value_option')?.textContent.trim() || '';
         console.log('Arish2');
         console.log(selectedBorder);
        $('.grid--product-images--partial')
            .attr('data-size', selectedSize)
            .attr('data-frame', selectedFrame)
            .attr('data-border', selectedBorder.replace(/\s+/g, '-'));
            
    }
    
    // $('input[name="Size"], input[name="Frame"], input[name="Border Options"]').change(function() {
    //     updateDataAttributes();
    // });
    //     updateDataAttributes();
// $('input[name="Border Options"]').change(function() {
//   $('input[type="radio"][name="Frame"]').prop('checked', true).trigger('change');
// });
   $('input[name="Frame"]').change(function() {
      var index = $('.product__thumbs--scroller [data-left-frame]').data('index');
      var flkty = Flickity.data('.product-slideshow');
           if(flkty)
      {
flkty.select(index);
      }
      
      
    });
  
});


